import { Select, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import assetUtils from "@shared/assetUtils";
import { assetService } from "../../../http/asset.service";
import { Asset } from "../../../models/asset";
import { CMSAsset } from "../../../models/CMS/cmsAsset";
import {
  ConditionalSectionWrapper,
  SectionWrapper,
} from "../../UI/SectionWrapper/SectionWrapper";
import { useSelector } from "react-redux";
import { AppState } from "@client/types/redux";

interface IChannelSelectorProps {
  currentValue?: string;
  onChange(newValue: string): void;
}

// Helper function to get title regardless of asset type
function getChannelTitle(channel: Asset | CMSAsset): string {
  if (channel instanceof CMSAsset) {
    return channel.getTitle("en");
  }
  return assetUtils.getTitle(channel, ["en", "sv"]);
}

export const ChannelSelector: React.FC<IChannelSelectorProps> = ({
  currentValue,
  onChange,
}) => {
  const [channels, setChannels] = useState<Array<Asset | CMSAsset>>([]);

  const settings = useSelector((state: AppState) => state.config);
  const showTransformationGUI = settings?.showTransformationGui;

  useEffect(() => {
    let sub;
    if (!settings) return;
    sub = assetService
      .getAssetsByQuery("", "", {
        type: "TV_CHANNEL",
        page: 1,
        pageSize: 100,
      })
      .subscribe((channels) => {
        setChannels(channels);
        sub.unsubscribe();
      });
  }, [settings]);

  return (
    <ConditionalSectionWrapper>
      <SectionWrapper>
        <h4>Channel</h4>
        <div className="input-group">
          <Select
            value={currentValue || ""}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            className="form-control"
          >
            <MenuItem value=""></MenuItem>
            {channels.map((c) => (
              <MenuItem value={c.assetId} key={c.assetId}>
                {getChannelTitle(c)}
              </MenuItem>
            ))}
          </Select>
        </div>
      </SectionWrapper>
    </ConditionalSectionWrapper>
  );
};
